var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 5.5,
    stroke: "#F1935C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 13.568V22.136C25.7301 22.6965 25.5996 23.2474 25.3658 23.7571C25.1321 24.2669 24.7997 24.7253 24.388 25.106C23.9759 25.4885 23.4925 25.786 22.9654 25.9817C22.4383 26.1773 21.8778 26.2671 21.316 26.246H13.726C13.1607 26.2719 12.5959 26.1859 12.064 25.993C11.532 25.8001 11.0433 25.5041 10.626 25.122C10.2103 24.7403 9.87454 24.2797 9.63833 23.7671C9.40211 23.2545 9.27011 22.7001 9.25 22.136V11.862C9.26985 11.3016 9.40042 10.7506 9.63418 10.2409C9.86794 9.73118 10.2003 9.27274 10.612 8.89203C11.0241 8.50955 11.5075 8.21201 12.0346 8.01641C12.5617 7.8208 13.1222 7.73096 13.684 7.75203H19.398C20.2703 7.74895 21.1123 8.07169 21.759 8.65703L24.719 11.379C25.0349 11.6511 25.2899 11.9866 25.4675 12.3638C25.6452 12.7409 25.7414 13.1512 25.75 13.568Z",
    fill: "#F1935C",
    stroke: "#F1935C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.499V22.273",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.606 18.3499L17.941 15.6849C17.8834 15.6266 17.8147 15.5803 17.739 15.5486C17.6633 15.517 17.5821 15.5007 17.5 15.5007C17.418 15.5007 17.3368 15.517 17.2611 15.5486C17.1854 15.5803 17.1167 15.6266 17.059 15.6849L14.394 18.3509",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.686 7.75293V11.3489C19.686 11.8359 19.88 12.3039 20.226 12.6489C20.5729 12.9943 21.0425 13.1881 21.532 13.1879H25.657",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/UploadFile.4e60c1a8649e6c2248b19e03c33855de.svg";
export { ForwardRef as ReactComponent };